/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFeatureModel } from '../../models/system-feature-model';

export interface GetSystemFeature$Params {
      body?: {
'id'?: number;
}
}

export function GetSystemFeature(http: HttpClient, rootUrl: string, params?: GetSystemFeature$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureModel>> {
  const rb = new RequestBuilder(rootUrl, GetSystemFeature.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFeatureModel>;
    })
  );
}

GetSystemFeature.PATH = '/api/SystemSettings/GetSystemFeature';
